import AuthService from '../../utilities/services/auth.service'
import { GeographicSalesIntelligenceWrapper } from '../../components'

export default function GeographicSalesIntelligencePage() {
  const organization = AuthService.getOrg()[0]

  return <GeographicSalesIntelligenceWrapper organization={organization} />
}
